"use strict";
// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGORA_LOKAD_ID = exports.AGORA_LOKAD_ID_STR = void 0;
const ecash_lib_1 = require("ecash-lib");
/** Agora LOKAD ID */
exports.AGORA_LOKAD_ID_STR = 'AGR0';
/** Agora LOKAD ID */
exports.AGORA_LOKAD_ID = (0, ecash_lib_1.strToBytes)(exports.AGORA_LOKAD_ID_STR);
//# sourceMappingURL=consts.js.map